<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<card-component class="has-table has-mobile-sort-spaced" :hasButtonSlot="true" title="一覧" icon="format-list-bulleted">
			<b-button slot="button" type="is-success" @click="$router.push({ name: 'staff-new' })">新規作成</b-button>
			<b-button slot="button" type="is-info" :loading="isExportLoading" @click="onExportButtonClick">CSV出力</b-button>

			<search-bar slot="toolbar" @search="onSearchClick">
				<div class="search-wrap" slot>
					<div class="row">
						<div class="search-type">
							<b-input type="text" placeholder="フリーワード" v-model="search.word" />
						</div>

						<div class="search-type ml-30">
							<div class="search-title">チーム</div>
							<b-select v-model="search.teamId">
								<option value="">未選択</option>
								<option v-for="(row, index) in teams" :key="index" :value="row.id">
									{{ row.name }}
								</option>
							</b-select>
						</div>

						<div class="search-type ml-30">
							<div class="search-title">権限</div>
							<b-select v-model="search.permissionId">
								<option value="">未選択</option>
								<option v-for="(row, index) in permissions" :key="index" :value="row.id">
									{{ row.name }}
								</option>
							</b-select>
						</div>
					</div>

					<div class="row">
						<div class="search-type">
							<div class="search-title">最終ログイン日</div>
							<date-picker :dateProvided="search.lastLogin"  @input="onLastLoginInput"></date-picker>
						</div>

						<div class="search-type ml-30">
							<div class="search-title">コイン最終贈呈日</div>
							<date-picker :dateProvided="search.lastPresent" @input="onLastPresentInput"></date-picker>
						</div>
					</div>
				</div>
			</search-bar>

			<b-table
				:loading="isLoading"
				:paginated="true"
				:per-page="$consts.TABLE_PER_PAGE"
				:striped="true"
				:hoverable="true"
				default-sort="name"
				:data="list"
				@page-change="onPageChange"
				>

				<template slot-scope="props">
					<b-table-column label="名前" field="name" sortable>
						{{ props.row.name }}
					</b-table-column>
					<b-table-column label="権限" field="permission" sortable>
						{{ props.row.permission }}
					</b-table-column>
					<b-table-column label="ログインID" field="login_id" sortable>
						{{ props.row.login_id }}
					</b-table-column>
					<b-table-column label="メールアドレス" field="email" sortable>
						{{ props.row.email }}
					</b-table-column>
					<b-table-column label="最終ログイン日" field="last_login" sortable>
						{{ props.row.last_login }}
					</b-table-column>
					<b-table-column label="コイン最終贈呈日" field="last_present" sortable>
						{{ props.row.last_present }}
					</b-table-column>
					<b-table-column label="アカウント有効" field="is_active" sortable centered>
						<b-icon type="is-success" icon="check" v-if="props.row.is_active"></b-icon>
					</b-table-column>
					<b-table-column label=" ">
						<div class="buttons is-right">
							<button class="button is-small is-warning" type="button" @click="$router.push({ name: 'staff-edit', params: { staffId: props.row.id }})">編集</button>
							<button class="button is-small is-danger" type="button" @click="onDeleteClick(props.row.id)">削除</button>
						</div>
					</b-table-column>
				</template>

				<section class="section" slot="empty">
					<table-empty :loading="isLoading"></table-empty>
				</section>

				<section class="page-info" slot="bottom-left">
					<page-info :current="currentPage" :data="list"></page-info>
				</section>
			</b-table>
		</card-component>
	</div>

</template>

<style lang="scss" scoped>
.search-wrap {
	flex-wrap: wrap;

	.search-type,
	.row {
		display: flex;
		align-items: center;
		margin: 5px 0;
	}

	.search-title {
		margin-right: 10px;
	}
}
</style>

<script>
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import TableEmpty from '@/components/TableEmpty'
import PageInfo from '@/components/PageInfo'
import SearchBar from '@/components/SearchBar'
import DatePicker from '@/components/DatePicker'

export default {
	name: 'Staff',
	components: {
		TitleBar,
		CardComponent,
		TableEmpty,
		PageInfo,
		SearchBar,
		DatePicker,
	},
	data() {
		return {
			isLoading: false,
			list: [],
			currentPage: 1,
			teams: [],
			permissions: [],
			search: {
				word: '',
				teamId: '',
				permissionId: '',
				lastLogin: '',
				lastPresent: '',
			},
			isExportLoading: false,
		}
	},
	computed: {
		titleStack () {
			return [
				'社員管理'
			]
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		onExportButtonClick: async function() {
			this.isExportLoading = true;

			let ep = 'staffs/export?' + this.createGetParam();
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.downloadCSV(res.data);
			} catch (error) {
				this.$utils.log(error);
				alert(error.response.data.message);
			} finally {
				this.isExportLoading = false;
			}
		},
		downloadCSV: function(data) {
			let fileName = `export_staff.csv`;
			this.$utils.downloadCSV(data, fileName, true);
		},
		onSearchClick: function() {
			this.getData();
		},
		onLastLoginInput: function(date) {
			this.search.lastLogin = date;
		},
		onLastPresentInput: function(date) {
			this.search.lastPresent = date;
		},
		init: function() {
			this.getData();
		},
		createGetParam: function() {
			return `word=${this.search.word}&team_id=${this.search.teamId}&permission_id=${this.search.permissionId}&last_login=${this.search.lastLogin}&last_present=${this.search.lastPresent}`;
		},
		getData: async function() {
			this.isLoading = true;
			let ep = 'staffs?' + this.createGetParam();
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.list = res.data.list;
				this.teams = res.data.teams;
				this.permissions = res.data.permissions;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onDeleteClick: async function(id) {
			if (!window.confirm(this.$consts.MSG_CONFIRM_DELETE)) {
				return false;
			}

			this.isLoading = true;
			let ep = 'staffs/' + id;
			this.$utils.log(ep);

			try {
				let res = await this.$api.delete(ep, null, true);
				this.$utils.log(res);
				this.list.some(function(v, i){
					if (v.id === id) this.list.splice(i, 1);
				}, this);
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onPageChange: function(val) {
			this.currentPage = val;
		},
	},
}
</script>
